<template>
  <div>
    <v-card flat
            tile>
      <v-toolbar color="secondary"
                 dark
                 flat>
        <v-toolbar-title>{{ $t('details') }}</v-toolbar-title>
      </v-toolbar>
      <event-details ref="eventDetails"
                     v-bind:event="event" />
    </v-card>
  </div>
</template>

<script>
  import EventDetails from '@/components/booking/EventDetails'

  export default {
    components: {
      EventDetails
    },
    name: 'EventDetailsCard',
    methods: {
      validate() {
        return this.$refs.eventDetails.validate()
      }
    },
    props: {
      event: Object
    }
  }
</script>

<i18n>
  {
    "de": {
      "details": "Details"
    },
    "en": {
      "details": "Details"
    }
  }
</i18n>